module.exports = __webpack_public_path__ + "img/icon.2150e0ee.png";